import { useAppSelector } from 'hooks/useStore';
import IQuiz from 'models/Quiz';
import { FC } from 'react';
import { selectQuiz } from 'store/quiz/quizSelectors';
import QuizTypes from 'types/QuizTypes';

const HomeTitles:FC = () => {
  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const isPollQuiz = quiz && quiz.type === QuizTypes.Poll;

  if (!quiz || !isPollQuiz) return null;

  const { title1, title2, title3 } = quiz.landingPage.callToAction;

  return (
    <div className="pb-4 text-white text-center uppercase font-bold">
      {title1 ? <p className="text-2xl mb-1">{title1}</p> : null}
      {title2 ? <p className="text-5xl font-extrabold mb-2">{title2}</p> : null}
      {title3 ? <p className="text-lg">{title3}</p> : null}
    </div>
  )
}

export default HomeTitles;
